import { PropsWithChildren } from 'react'

const ToastIcon = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex size-7 items-center justify-center">{children}</div>
  )
}

export { ToastIcon }
